var __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  __indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

define(['jquery', 'core', 'model/base', 'common/location'], function($, core, BaseModel, locationConfig) {
  var FileModel;
  return FileModel = (function(_super) {

    __extends(FileModel, _super);

    function FileModel() {
      FileModel.__super__.constructor.apply(this, arguments);
    }

    FileModel.prototype.pathRoot = core.getConfig().apiPrefix + 'file.json';

    FileModel.prototype.supportedRotationOrientations = ['right', 'down', 'left'];

    FileModel.prototype.defaults = function() {
      return {
        id: null,
        clientId: core.getCurrentClientId(),
        pages: [],
        fileName: '',
        originalFileName: '',
        displayName: ''
      };
    };

    FileModel.prototype.save = function(attributes, options) {
      options = _.defaults(options || {}, {
        url: this.url() + '/metadata'
      });
      return FileModel.__super__.save.call(this, attributes, options);
    };

    FileModel.prototype.getAllPagesByType = function(type) {
      var page, _i, _len, _ref, _results;
      _ref = this.get('pages');
      _results = [];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        page = _ref[_i];
        _results.push(page[type + 'View']);
      }
      return _results;
    };

    FileModel.prototype.downloadSplittedPages = function() {
      return location.href = this.url() + '/split_and_download';
    };

    FileModel.prototype.download = function() {
      return location.href = this.url() + '/download';
    };

    FileModel.prototype.downloadAsStatement = function(documentId) {
      return location.href = this.url() + ("/downloadAsStatement/" + documentId);
    };

    FileModel.prototype.rotatePage = function(page, orientation) {
      if (__indexOf.call(this.supportedRotationOrientations, orientation) < 0) {
        return;
      }
      return this.customCall("/rotate/" + page + "/" + orientation, 'PUT');
    };

    FileModel.prototype.insertPage = function(insertedFileId, page, position) {
      return this.customCall("/insert_file/" + insertedFileId + "/" + position + "/" + page, 'PUT');
    };

    FileModel.prototype.deletePage = function(page) {
      return this.customCall("/delete_page/" + page, 'DELETE');
    };

    return FileModel;

  })(BaseModel);
});
